<template>
<div class="vx-row">
    <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <vx-card title="Filter">
            <div class="filter-container">
                <h6 class="font-bold mb-3">Quick Range</h6>
                <div class="vx-row mb-2">
                    <div class="vx-col w-1/2 mb-2" v-for="range in quickRanges" :key="range.key">
                        <vs-button class="w-full" size="small" :type="activeRange === range.key ? 'filled' : 'border'" @click="applyQuickRange(range.key)">{{ range.label }}</vs-button>
                    </div>
                </div>

                <vs-divider />

                <h6 class="font-bold mb-3">Start Date</h6>
                <div>
                    <flat-pickr v-model="fromDate" placeholder="From Date" @on-change="onFromChange" class="w-full" />
                </div>

                <vs-divider />

                <h6 class="font-bold mb-4">End Date</h6>
                <div>
                    <flat-pickr v-model="toDate" placeholder="To Date" @on-change="onToChange" class="w-full" />
                </div>

                <vs-divider />

                <h6 class="font-bold mb-4">Select Product</h6>
                <div>
                    <select v-model="selectedProduct" @change="generateReport" class="w-full product-select">
                        <option value="00000000-0000-0000-0000-000000000000">All Products</option>
                        <option v-if="dayPassProduct" :value="dayPassProduct.id">{{ dayPassProduct.name }}</option>
                        <optgroup label="Active" v-if="activeProducts.length > 0">
                            <option :key="item.id" :value="item.id" v-for="item in activeProducts">{{ item.name }}</option>
                        </optgroup>
                        <optgroup label="Past Seasons" v-if="pastProducts.length > 0">
                            <option :key="item.id" :value="item.id" v-for="item in pastProducts">{{ item.name }}</option>
                        </optgroup>
                    </select>
                </div>

                <vs-divider />

                <div class="flex justify-center">
                    <vs-button class="w-full" slot-scope="{ canRefine, refine }" @click.prevent="refine" :disabled="!canRefine">Remove Filters</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
    <div class="vx-col md:w-3/4 sm:w-1/2 w-full">
        <div class="relative mb-2">
            <div class="vx-row">
                <div class="vx-col md:w-1/6 sm:w-1/3 w-full">
                    <statistics-card-line hideChart icon="CreditCardIcon" :statistic="reportProductCount" statisticTitle="Products" />
                </div>
                <div class="vx-col md:w-1/6 sm:w-1/3 w-full">
                    <statistics-card-line hideChart icon="CreditCardIcon" :statistic="totalPassCount" statisticTitle="Total Passes" />
                </div>
                <div class="vx-col md:w-1/6 sm:w-1/3 w-full">
                    <statistics-card-line hideChart icon="CheckIcon" :statistic="totalPaid" statisticTitle="Paid" />
                </div>
                <div class="vx-col md:w-1/6 sm:w-1/3 w-full">
                    <statistics-card-line hideChart icon="PercentIcon" color="warning" :statistic="totalFree" statisticTitle="Free (100% promo)" />
                </div>
                <div class="vx-col md:w-1/6 sm:w-1/3 w-full">
                    <statistics-card-line hideChart icon="EditIcon" :statistic="totalManual" statisticTitle="Manual Day Passes" />
                </div>
                <div class="vx-col md:w-1/6 sm:w-1/3 w-full">
                    <statistics-card-line hideChart icon="DollarSignIcon" color="success" :statistic="totalAmount | formatCurrency" statisticTitle="Total Amount" />
                </div>
            </div>
        </div>

        <vx-card class="item-details mb-base welcomeCard" title="Sales By Product">
            <template slot="actions">
                <vs-button color="danger" @click="downloadPdf">Report</vs-button>
                <vs-button class="ml-2" color="success" @click="downloadexcel">Export</vs-button>
            </template>
            <vs-table stripe :data="reportDataList">
                <template #thead>
                    <vs-th>Date</vs-th>
                    <vs-th>Product</vs-th>
                    <vs-th>Sold</vs-th>
                    <vs-th>Paid</vs-th>
                    <vs-th>Free</vs-th>
                    <vs-th>Promo Redeemed</vs-th>
                    <vs-th>Stripe</vs-th>
                    <vs-th>Manual</vs-th>
                    <vs-th>Total Amount</vs-th>
                </template>
                <template>
                    <vs-tr :key="i" v-for="(tr, i) in reportDataList" :data="tr">
                        <vs-td>{{ tr.transactionDate | formatLongDate }}</vs-td>
                        <vs-td>{{ tr.productName }}</vs-td>
                        <vs-td>{{ tr.countSold }}</vs-td>
                        <vs-td>{{ tr.countPaid }}</vs-td>
                        <vs-td>{{ tr.countFree }}</vs-td>
                        <vs-td>{{ tr.promoCodesRedeemed }}</vs-td>
                        <vs-td>{{ tr.countStripe === null || tr.countStripe === undefined ? '–' : tr.countStripe }}</vs-td>
                        <vs-td>{{ tr.countManual === null || tr.countManual === undefined ? '–' : tr.countManual }}</vs-td>
                        <vs-td>{{ tr.totalAmount | formatCurrency }}</vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
</div>
</template>

<script>
import {
    customMessages
} from "./../../filters/validationmessage";

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from 'moment'

import {
    reportsData
} from "@/store/api/report";

import {
    productData
} from "@/store/api/product";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
    components: {
        flatPickr,
        VuePerfectScrollbar,
        StatisticsCardLine
    },
    data() {
        return {
            customMessages,
            selectedProduct: "00000000-0000-0000-0000-000000000000",
            dayPassProductName: "Day Pass",
            startTime: null,
            endTime: null,
            isResourceLoaded: true,
            fromDate: null,
            toDate: null,
            productList: [],
            reportDataList: [],
            isFilterSidebarActive: true,
            activeRange: null,
            quickRanges: [{
                    key: 'thisMonth',
                    label: 'This Month'
                },
                {
                    key: 'lastMonth',
                    label: 'Last Month'
                },
                {
                    key: 'lastQuarter',
                    label: 'Last Quarter'
                },
                {
                    key: 'thisYear',
                    label: 'This Year'
                },
            ],
            configFromdateTimePicker: {
                maxDate: null,
                altFormat: 'd-m-Y',
                altInput: true,
                dateFormat: 'Y-m-d',
            },
            configTodateTimePicker: {
                minDate: null,
                altFormat: 'd-m-Y',
                altInput: true,
                dateFormat: 'Y-m-d',
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.7
            }
        };
    },
    async created() {
        this.fromDate = moment().add(-7, 'days').format();
        this.toDate = moment().format();
        await this.loadProduct();
        await this.generateReport();
    },
    computed: {
        scrollbarTag() {
            return this.$store.getters.scrollbarTag;
        },
        totalPassCount() {
            let value = "0";
            if (this.reportDataList.length > 0) {
                value = this.reportDataList.reduce((acc, item) => acc + item.countSold, 0);
            }
            return value;
        },
        totalAmount() {
            let value = "0";
            if (this.reportDataList.length > 0) {
                value = this.reportDataList.reduce((acc, item) => acc + item.totalAmount, 0);
            }
            return value;
        },
        totalPaid() {
            return this.reportDataList.reduce((acc, item) => acc + (item.countPaid || 0), 0);
        },
        totalFree() {
            return this.reportDataList.reduce((acc, item) => acc + (item.countFree || 0), 0);
        },
        totalManual() {
            return this.reportDataList.reduce((acc, item) => acc + (item.countManual || 0), 0);
        },
        dayPassProduct() {
            return this.productList.find(p => this.isDayPass(p)) || null;
        },
        seasonProducts() {
            return this.productList.filter(p => !this.isDayPass(p));
        },
        activeProducts() {
            const today = moment().startOf('day');
            return this.seasonProducts.filter(p => moment(p.endDate).isSameOrAfter(today));
        },
        pastProducts() {
            const today = moment().startOf('day');
            return this.seasonProducts
                .filter(p => moment(p.endDate).isBefore(today))
                .sort((a, b) => moment(b.endDate).diff(moment(a.endDate)));
        },
        reportProductCount() {
            const ids = new Set(this.reportDataList.map(item => item.productId));
            return ids.size;
        },
    },
    methods: {
        isDayPass(product) {
            return (product.name || '').trim().toLowerCase() === this.dayPassProductName.toLowerCase();
        },
        async loadProduct() {
            this.productList = await productData.SearchProducts(true, true);
        },
        async downloadPdf() {
            const reportParameter = {
                startDate: this.fromDate,
                endDate: this.toDate,
                productId: this.selectedProduct
            };

            let data = await reportsData.exportToPdfSalesReportByProduct(reportParameter);
            window.open(data.url, '_blank').focus();
        },
        async downloadexcel() {
            const reportParameter = {
                startDate: this.fromDate,
                endDate: this.toDate,
                productId: this.selectedProduct
            };

            let data = await reportsData.exportToExcelSalesReportByProduct(reportParameter);
            window.open(data.url, '_blank').focus();
        },
        async generateReport() {
            const reportParameter = {
                startDate: this.fromDate,
                endDate: this.toDate,
                productId: this.selectedProduct
            };

            this.reportDataList = await reportsData.salesReportByProduct(reportParameter);
        },
        async applyQuickRange(key) {
            let from, to;
            switch (key) {
                case 'thisMonth':
                    from = moment().startOf('month');
                    to = moment();
                    break;
                case 'lastMonth':
                    from = moment().subtract(1, 'month').startOf('month');
                    to = moment().subtract(1, 'month').endOf('month');
                    break;
                case 'lastQuarter':
                    from = moment().subtract(1, 'quarter').startOf('quarter');
                    to = moment().subtract(1, 'quarter').endOf('quarter');
                    break;
                case 'thisYear':
                    from = moment().startOf('year');
                    to = moment();
                    break;
                default:
                    return;
            }
            this.activeRange = key;
            this.fromDate = from.format('YYYY-MM-DD');
            this.toDate = to.format('YYYY-MM-DD');
            await this.generateReport();
        },
        async onFromChange(selectedDates, dateStr, instance) {
            this.activeRange = null;
            this.$set(this.configTodateTimePicker, "minDate", dateStr);
            await this.generateReport();
        },
        async onToChange(selectedDates, dateStr, instance) {
            this.activeRange = null;
            this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
            await this.generateReport();
        },
    }
};
</script>

<style scoped>
.product-select {
    width: 100%;
    padding: 0.7rem 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    background: #fff;
    font-family: inherit;
    font-size: 1rem;
    color: inherit;
}

.product-select:focus {
    outline: none;
    border-color: rgba(var(--vs-primary), 1);
}
</style>
